
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wijn/[wineId]",
      function () {
        return require("private-next-pages/wijn/[wineId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wijn/[wineId]"])
      });
    }
  